// src/pages/painel/PainelAguaDia.js
import React, { useState, useEffect } from 'react';
import './painelAguaDia.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTint } from '@fortawesome/free-solid-svg-icons';

const COOLDOWN_MS = 3000;

const PainelAguaDia = ({
  agua,
  metaAgua,
  progressoAgua,
  inputAgua,
  setInputAgua,
  registrarAgua,
  botoesDesativados,
  mostrarBotoes
}) => {
  // 🔒 controle individual de cooldown
  const [cooldowns, setCooldowns] = useState({
    200: 0,
    500: 0,
    custom: 0
  });

  // ⏱️ timer para animação
  useEffect(() => {
    const interval = setInterval(() => {
      setCooldowns((prev) => {
        const atualizado = { ...prev };
        let mudou = false;

        Object.keys(atualizado).forEach((k) => {
          if (atualizado[k] > 0) {
            atualizado[k] = Math.max(0, atualizado[k] - 100);
            mudou = true;
          }
        });

        return mudou ? atualizado : prev;
      });
    }, 100);

    return () => clearInterval(interval);
  }, []);

  const handleRegistrar = (valor, chave) => {
    if (cooldowns[chave] > 0 || botoesDesativados) return;

    registrarAgua(valor);

    setCooldowns((prev) => ({
      ...prev,
      [chave]: COOLDOWN_MS
    }));
  };

  const progressoCooldown = (chave) =>
    cooldowns[chave] > 0
      ? (cooldowns[chave] / COOLDOWN_MS) * 100
      : 0;

  return (
    <div className="painel-bloco">
      <h3>
        <FontAwesomeIcon icon={faTint} className="icone-agua" /> Consumo de Água
      </h3>

      <div className="painel-barra agua">
        <div
          className="preenchido azul"
          style={{ width: `${progressoAgua}%` }}
        ></div>
      </div>

      <p>
        {agua}ml de {metaAgua}ml
      </p>

      {mostrarBotoes && (
        <div className="painel-botoes">
          {/* +200ml */}
          <div className="botao-cooldown-wrapper">
            <button
              onClick={() => handleRegistrar(200, 200)}
              disabled={botoesDesativados || cooldowns[200] > 0}
            >
              +200ml
            </button>
            {cooldowns[200] > 0 && (
              <div
                className="cooldown-bar"
                style={{ width: `${progressoCooldown(200)}%` }}
              />
            )}
          </div>

          {/* +500ml */}
          <div className="botao-cooldown-wrapper">
            <button
              onClick={() => handleRegistrar(500, 500)}
              disabled={botoesDesativados || cooldowns[500] > 0}
            >
              +500ml
            </button>
            {cooldowns[500] > 0 && (
              <div
                className="cooldown-bar"
                style={{ width: `${progressoCooldown(500)}%` }}
              />
            )}
          </div>

          {/* custom */}
          <div className="custom-agua">
            <input
              type="number"
              placeholder="ml"
              value={inputAgua}
              onChange={(e) => setInputAgua(e.target.value)}
              disabled={botoesDesativados || cooldowns.custom > 0}
            />

            <div className="botao-cooldown-wrapper">
              <button
                onClick={() => handleRegistrar(inputAgua, 'custom')}
                disabled={
                  botoesDesativados || cooldowns.custom > 0 || !inputAgua
                }
              >
                Registrar
              </button>

              {cooldowns.custom > 0 && (
                <div
                  className="cooldown-bar"
                  style={{ width: `${progressoCooldown('custom')}%` }}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PainelAguaDia;
